module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "container page-container"
  }, [_c('h1', {
    staticClass: "project"
  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('p', {
    staticClass: "edited"
  }, [_vm._v("Edited: "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.edited)))]), _c('br'), _vm._v("\n  Created: "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.prettyDate(_vm.project.created)))])]), _vm._v(" "), (_vm.user.isAdmin) ? _c('div', {
    staticClass: "add-project"
  }, [_c('el-form', {
    staticClass: "form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Edit Project Name"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.updateName
    },
    model: {
      value: (_vm.project.name),
      callback: function($$v) {
        _vm.project.name = $$v
      },
      expression: "project.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Add Project Data"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.updateFile
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getExportActionsDef()
      }
    }
  }, [_vm._v("Export "), _c('i', {
    staticClass: "el-icon-document el-icon-plus"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openDatabase()
      }
    }
  }, [_vm._v("View JSON "), _c('i', {
    staticClass: "el-icon-document el-icon-right"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.hideEmptyTables = !_vm.hideEmptyTables
      }
    }
  }, [_vm._v(_vm._s(_vm.hideEmptyTables ? "Show Empty Cells" : "Hide Empty Cells"))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-delete",
    attrs: {
      "type": "danger",
      "disabled": !_vm.user.isAdmin
    },
    on: {
      "click": function($event) {
        _vm.deleteFormVisible = true
      }
    }
  }, [_vm._v("Delete Project "), _c('i', {
    staticClass: "el-icon-delete el-icon-right"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row), function(value, propertyName, index) {
          return (propertyName !== 'unit') ? _c('div', [(_vm.hideEmptyTables && (value === undefined || value === null || value === '')) ? _c('el-row') : _c('el-row', [(value !== undefined && value !== null && value !== '') ? _c('b', [_vm._v(_vm._s(propertyName) + ":")]) : _c('b', [_c('s', [_vm._v(_vm._s(propertyName) + ":")])]), _vm._v(" "), _c('i', [_vm._v(_vm._s(value))]), _vm._v(" "), _c('hr')])], 1) : _vm._e()
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unit",
      "prop": "unit"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "prop": "status"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Enter Custom Ordering",
      "readonly": !_vm.user.isAdmin
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }, [_vm._v(_vm._s(_vm.ordering)), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.user.isAdmin
    },
    on: {
      "click": _vm.updateOrdering
    },
    slot: "append"
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Are You Sure You Want To Delete This Project?",
      "visible": _vm.deleteFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.deleteFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "inline": true,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteFormVisible = false
      }
    }
  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteProject()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96da584c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 345
// module chunks = 2